// extracted by mini-css-extract-plugin
export default {"prefix":"variants-module__prefix___573025"};